export const GoogleMapApiConfig = 'AIzaSyBXlB_pGWDyM_qVWt7HbVgeysFcbmFLSU4';